import { Component, Input, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { animationFrameScheduler } from 'rxjs';
import { SharedService } from 'src/app/shared.service';
import swal from 'sweetalert';
@Component({
  selector: 'app-leave-summary',
  templateUrl: './leave-summary.component.html',
  styleUrls: ['./leave-summary.component.scss']
})
export class LeaveSummaryComponent implements OnInit {
  @Input() employee: any;
  @Input() attendanceList: any;
  @Input() employeeList: any;
  @Input() leaveList: any;
  @Input() monthList: any;
  @Input() clockifyList: any;
  @Input() monthNum: any;
  @Input() year: any;
  compensationlist: any = [];
  setting: any = [];
  settingId = 3;
  casualBalance: any;
  annualBalance: any;
  allLeavesMarkedFlag: boolean = true;
  constructor(private service: SharedService, private router: Router) { }
  ngOnInit(): void {
    this.RefreshSetting();
    this.RefreshCompensations();
  }
  Test() {
    swal
      ({
        title: "Are you sure you're done marking all leaves?",
        text: "Some leaves are still unmarked and may need your input",
        icon: "warning",
        buttons:
        {
          cancel: true,
          confirm: true,
        },
        dangerMode: true,
      })
      .then((confirm) => {
        if (confirm) {
          swal("SUCCESS", "Leave Reports have been generated. You will now be redirected to the Leave Reports page", "success")
            .then((confirm) => {
              this.router.navigate(['report']);
            });
        }
      })
    // }
  }
  GenerateSummaries() {
    // if (!this.allLeavesMarkedFlag)
    // {
    swal
      ({
        title: "Are you sure you're done marking all leaves?",
        text: "Some leaves are still unmarked and may need your input",
        icon: "warning",
        buttons:
        {
          cancel: true,
          confirm: true,
        },
        dangerMode: true,
      })
      .then((confirm) => {
        if (confirm) {
          this.ComputeLeaves();
        }
      })
  }
  GetCurrentDate() {
    let today = new Date().toISOString().slice(0, 10)
    return today
  }
  // BreakEmployeeList()
  // {
  //   var temp =
  //   {
  //     FirstName: this.employeeList[0].FirstName,
  //     pkEmpId: this.employeeList[0].pkEmpId,
  //     LastName: this.employeeList[0].LastName,
  //     Gender: this.employeeList[0].Gender,
  //     Age: this.employeeList[0].Age,
  //     EmpEmail: this.employeeList[0].EmpEmail,
  //     Designation: this.employeeList[0].Designation,
  //     ContactNumber: this.employeeList[0].ContactNumber,
  //     CasualLeaveBalance: this.employeeList[0].CasualLeaveBalance,
  //     AnnualLeaveBalance: this.employeeList[0].AnnualLeaveBalance,
  //     IsPermanent: this.employeeList[0].IsPermanent,
  //     ClockifyId: this.employeeList[0].ClockifyId,
  //     OnLeave: this.employeeList[0].OnLeave,
  //     MaternityLimit: this.employeeList[0].MaternityLimit,
  //   }
  //   this.tempList.push(temp)
  // }
  RefreshSetting() {
    this.service.GetSetting(3).subscribe(data => {
      this.setting = data;
    })
  }
  RefreshCompensations() {
    this.service.GetMonthCompensations().subscribe(data => {
      this.compensationlist = data;
    })
  }
  CheckCasualBalance(id: number) {
    for (var employee of this.employeeList) {
      if (employee.pkEmpId == id) {
        // this.AddCasualBalance(employee);
        if (employee.CasualLeaveBalance > this.setting[0].CasualMinLimit) {
          return true
        }
      }
    }
    return false
  }
  CheckAnnualBalance(id: number) {
    for (var employee of this.employeeList) {
      if (employee.pkEmpId == id) {
        // this.AddAnnualBalance(employee);
        if (employee.AnnualLeaveBalance > this.setting[0].AnnualMinLimit) {
          return true
        }
      }
    }
    return false
  }
  CheckWeekend(date: any) {
    for (let i = 0; i < this.monthList.length; i++) {
      if (this.monthList[i]['pkDate'] == date) {
        if (this.monthList[i]['IsBusinessDay'] == false) {
          return true
        }
      }
    }
    return false
  }
  AddCasualBalance(employee: any) {
    if (this.monthNum == 1 || this.monthNum == 4 || this.monthNum == 7 || this.monthNum == 10) {
      if (employee.IsPermanent == true) {
        employee.CasualLeaveBalance = employee.CasualLeaveBalance + 3;
        return 3
      }
      else {
        return 0
      }
    }
    else {
      return 0
    }
  }
  AddAnnualBalance(employee: any) {
    if (this.monthNum == 1) {
      if (employee.IsPermanent == true) {
        employee.AnnualLeaveBalance = employee.AnnualLeaveBalance + 8;
        return 8
      }
      else {
        return 0
      }
    }
    else {
      return 0
    }
  }
  LeavesLapsed(employee: any) {
    if (this.monthNum == 12) {
      var temp = employee.AnnualLeaveBalance;
      employee.AnnualLeaveBalance = 0;
      return temp;
    }
    else {
      return 0;
    }
  }
  IsPublicHoliday(date: any) {
    let temp = this.monthList.find((i: { pkDate: any; }) => i.pkDate === date);
    if (temp.IsHoliday) {
      return true
    }
    else {
      return false
    }
  }
  ComputeNonTechnicalLeaves(employee: any) {
    var CasualCounter = 0;
    var AnnualCounter = 0;
    var LWPCounter = 0;
    var NELCounter = 0;
    var OffDayCounter = 0;
    this.casualBalance = employee.CasualLeaveBalance;
    this.annualBalance = employee.AnnualLeaveBalance;
    var CasualBalanceAdded = this.AddCasualBalance(employee);
    var AnnualBalanceAdded = this.AddAnnualBalance(employee);
    for (var leave of this.leaveList) {
      if (leave.fkEmpId == employee.pkEmpId) {
        if (leave.Type == 'Annual') {
          //do annual
          if (this.CheckAnnualBalance(employee.pkEmpId)) {
            AnnualCounter++
            employee.AnnualLeaveBalance--;
          }
          else {
            if (this.CheckCasualBalance(employee.pkEmpId)) {
              CasualCounter++
              employee.CasualLeaveBalance--;
            }
            else {
              NELCounter++
            }
          }
        }
        else if (leave.Type == 'Casual') {
          //do casual
          if (this.CheckCasualBalance(employee.pkEmpId)) {
            CasualCounter++
            employee.CasualLeaveBalance--;
          }
          else {
            NELCounter++
          }
        }
        else if (leave.Type == 'Leave w/o Pay') {
          //do LWP
          LWPCounter++
        }
        else {
          this.allLeavesMarkedFlag = false;
          //console.log("One or more employee leaves need your input")
        }
      }
    }
    for (var attendance of this.attendanceList) {
      if (this.CheckWeekend(attendance.Date)) {
        if (attendance.fkEmpId == employee.pkEmpId) {
          if (attendance.WorkHours == 'Full') {
            OffDayCounter++;
            employee.CasualLeaveBalance++;
          }
          else if (attendance.WorkHours == 'Half') {
            OffDayCounter = OffDayCounter + 0.5;
            employee.CasualLeaveBalance = employee.CasualLeaveBalance + 0.5;
          }
          else if (attendance.WorkHours == 'Quarter') {
            OffDayCounter = OffDayCounter + 0.25;
            employee.CasualLeaveBalance = employee.CasualLeaveBalance + 0.25;
          }
        }
      }
      else {
        if (attendance.fkEmpId == employee.pkEmpId) {
          if (attendance.WorkHours == 'Half') {
            CasualCounter = CasualCounter + 0.5;
            employee.CasualLeaveBalance = employee.CasualLeaveBalance - 0.5;
          }
          else if (attendance.WorkHours == 'Quarter') {
            CasualCounter = CasualCounter + 0.25;
            employee.CasualLeaveBalance = employee.CasualLeaveBalance - 0.75;
          }
        }
      }
    }
    if (!this.CheckAnnualBalance(employee.pkEmpId)) {
      var overLimit = (employee.AnnualLeaveBalance - this.setting[0].AnnualMinLimit);
      employee.CasualLeaveBalance = employee.CasualLeaveBalance + overLimit;
      employee.AnnualLeaveBalance = employee.AnnualLeaveBalance - overLimit;
    }
    if (!this.CheckCasualBalance(employee.pkEmpId)) {
      var overLimit = (employee.CasualLeaveBalance - this.setting[0].CasualMinLimit);
      NELCounter = NELCounter + overLimit;
      employee.CasualLeaveBalance = employee.CasualLeaveBalance - overLimit;
    }
    var val =
    {
      fkEmpId: employee.pkEmpId,
      fkSettingId: this.setting[0].pkSettingId,
      Date: new Date(`${this.year}-${this.monthNum}-01 00:00 PST`).toISOString().split('T')[0],
      CasualBalanceAdded: CasualBalanceAdded,
      AnnualBalanceAdded: AnnualBalanceAdded,
      CasualLeaves: CasualCounter,
      AnnualLeaves: AnnualCounter,
      LWP: LWPCounter,
      NotEnoughLeaves: NELCounter,
      OffDaysWorked: OffDayCounter,
      NewCasualBalance: (employee.CasualLeaveBalance),
      NewAnnualBalance: (employee.AnnualLeaveBalance),
      OldCasualBalance: this.casualBalance,
      OldAnnualBalance: this.annualBalance,
      Leaveslapsed: this.LeavesLapsed(employee),
      LeavesCashed: 0,
      DateCreated: this.GetCurrentDate()
    }
    this.service.AddSummary(val).subscribe(data => {
      // console.log(data)
    });
  }
  ComputeTechnicalLeaves(employee: any) {
    var CasualCounter = 0;
    var AnnualCounter = 0;
    var LWPCounter = 0;
    var NELCounter = 0;
    var OffDayCounter = 0;
    this.casualBalance = employee.CasualLeaveBalance;
    this.annualBalance = employee.AnnualLeaveBalance;
    var CasualBalanceAdded = this.AddCasualBalance(employee);
    var AnnualBalanceAdded = this.AddAnnualBalance(employee);
    for (var leave of this.leaveList) {
      if (leave.fkEmpId == employee.pkEmpId) {
        if (leave.Type == 'Annual') {
          //do annual
          if (this.CheckAnnualBalance(employee.pkEmpId)) {
            AnnualCounter++;
            employee.AnnualLeaveBalance--;
          }
          else {
            if (this.CheckCasualBalance(employee.pkEmpId)) {
              CasualCounter++;
              employee.CasualLeaveBalance--;
            }
            else {
              NELCounter++
            }
          }
        }
        else if (leave.Type == 'Casual') {
          //do casual
          if (this.CheckCasualBalance(employee.pkEmpId)) {
            CasualCounter++
            employee.CasualLeaveBalance--;
          }
          else {
            NELCounter++
          }
        }
        else if (leave.Type == 'Leave w/o Pay') {
          //do LWP
          console.log('here');
          LWPCounter++
        }
        else {
          this.allLeavesMarkedFlag = false;
          //console.log("One or more employee leaves need your input")
        }
      }
    }
    for (var clockify of this.clockifyList) {
      if (this.CheckWeekend(clockify.Date) || this.IsPublicHoliday(clockify.Date)) {
        if (clockify.ClockifyId == employee.ClockifyId) {
          if (clockify.WorkHours == 'Full') {
            OffDayCounter++;
            employee.CasualLeaveBalance++
          }
          else if (clockify.WorkHours == 'Half') {
            OffDayCounter = OffDayCounter + 0.5;
            employee.CasualLeaveBalance = employee.CasualLeaveBalance + 0.5;
          }
          else if (clockify.WorkHours == 'Quarter') {
            OffDayCounter = OffDayCounter + 0.25
            employee.CasualLeaveBalance = employee.CasualLeaveBalance + 0.25;
          }
        }
      }
      else {
        if (clockify.ClockifyId == employee.ClockifyId) {
          if (clockify.WorkHours == 'Half') {
            if (this.CheckCasualBalance(employee.pkEmpId)) {
              CasualCounter = CasualCounter + 0.5;
              employee.CasualLeaveBalance = employee.CasualLeaveBalance - 0.5;
            }
            else {
              NELCounter = NELCounter + 0.5;
            }
          }
          else if (clockify.WorkHours == 'Quarter') {
            if (this.CheckCasualBalance(employee.pkEmpId)) {
              CasualCounter = CasualCounter + 0.75;
              employee.CasualLeaveBalance = employee.CasualLeaveBalance - 0.75;
            }
            else {
              NELCounter = NELCounter + 0.75;
            }
          }
        }
      }
    }
    if (!this.CheckAnnualBalance(employee.pkEmpId)) {
      var overLimit = (employee.AnnualLeaveBalance - this.setting[0].AnnualMinLimit);
      employee.CasualLeaveBalance = employee.CasualLeaveBalance + Math.abs(overLimit);
      employee.AnnualLeaveBalance = employee.AnnualLeaveBalance - Math.abs(overLimit);
    }
    if (!this.CheckCasualBalance(employee.pkEmpId)) {
      var overLimit = (employee.CasualLeaveBalance - this.setting[0].CasualMinLimit);
      NELCounter = NELCounter + Math.abs(overLimit);
      employee.CasualLeaveBalance = employee.CasualLeaveBalance + Math.abs(overLimit);
    }
    var val =
    {
      fkEmpId: employee.pkEmpId,
      fkSettingId: this.setting[0].pkSettingId,
      Date: new Date(`${this.year}-${this.monthNum}-01 00:00 PST`).toISOString().split('T')[0],
      CasualBalanceAdded: CasualBalanceAdded,
      AnnualBalanceAdded: AnnualBalanceAdded,
      CasualLeaves: CasualCounter,
      AnnualLeaves: AnnualCounter,
      LWP: LWPCounter,
      NotEnoughLeaves: NELCounter,
      OffDaysWorked: OffDayCounter,
      NewCasualBalance: (employee.CasualLeaveBalance),
      NewAnnualBalance: (employee.AnnualLeaveBalance),
      OldCasualBalance: this.casualBalance,
      OldAnnualBalance: this.annualBalance,
      Leaveslapsed: this.LeavesLapsed(employee),
      LeavesCashed: 0,
      DateCreated: this.GetCurrentDate()
    }
    this.service.AddSummary(val).subscribe(data => {
      //console.log(data)
    });
  }
  ComputeLeaves() {
    for (var employee of this.employeeList) {
      if (employee.ClockifyId == '') {
        this.ComputeNonTechnicalLeaves(employee)
      }
      else {
        this.ComputeTechnicalLeaves(employee)
      }
    }
    localStorage.setItem('summaryLastGenerated', new Date().toISOString());
    this.SetLastSummaryDate(this.settingId, this.monthNum, this.year)
    swal("SUCCESS", "Leave Reports have been generated. You will now be redirected to the Leave Reports page", "success")
      .then((confirm) => {
        this.router.navigate(['report']);
      });
  }
  SetLastSummaryDate(settingId: number, month: number, year: number) {
    this.service.UpdateLastSummaryDate(settingId, month, year).subscribe(data => {
    });
  }
}